import { render, staticRenderFns } from "./StoreDescription.vue?vue&type=template&id=5a6a57a6&scoped=true&"
import script from "./StoreDescription.vue?vue&type=script&lang=js&"
export * from "./StoreDescription.vue?vue&type=script&lang=js&"
import style0 from "./StoreDescription.vue?vue&type=style&index=0&id=5a6a57a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6a57a6",
  null
  
)

export default component.exports